<template>
  <div>
    <el-row style="margin-bottom: 10px;">
      <el-button type="primary" @click="onConfirmSort" v-if="operationType!=='view'">{{ $t('common.confirm') }}</el-button>
      <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
    </el-row>
    <el-table :data="tableData" border row-key="id" ref="sortableTable" :key="refreshKey" style="width: 100%;">
      <el-table-column label="序号" prop="sortIndex" width="80"></el-table-column>
      <el-table-column label="拖拽排序" width="80" align="center" v-if="operationType!=='view'">
        <template slot-scope="scope">
          <i class="fas fa-grip-vertical drag-handle el-icon-rank"></i>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="参数编码"></el-table-column>
      <el-table-column prop="name" label="参数名称"></el-table-column>
      <el-table-column label="操作" width="180" align="center" v-if="operationType!=='view'">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-top" size="mini" @click="moveUp(scope.$index)" :disabled="scope.$index === 0">升序</el-button>
          <el-button type="primary" icon="el-icon-bottom" size="mini" @click="moveDown(scope.$index)" :disabled="scope.$index === tableData.length - 1">降序</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
export default {
  props: ['sortData', 'operationType'],
  data() {
    return {
      tableData: [],
      refreshKey: 0,
      sortableInstance: null // 存储Sortable实例，用于销毁旧实例
    }
  },
  watch: {
    sortData: {
      handler(val) {
        if (val) {
          this.tableData = val
          // 数据初始化后重新创建拖拽实例
          this.$nextTick(() => {
            this.initSortable()
          })
        }
      },
      deep: true,
      immediate: true,
    },
    refreshKey() {
      // 等待表格DOM更新完成后再初始化
      this.$nextTick(() => {
        this.initSortable();
      });
    }
  },
  beforeDestroy() {
    // 组件销毁时清理实例
    if (this.sortableInstance) {
      this.sortableInstance.destroy()
    }
  },
  // mounted() {
  //   this.initSortable();
  // },
  methods: {
    // 初始化拖拽排序
    initSortable() {
      // 先销毁已存在的实例，避免重复绑定
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
      }
      const table = this.$refs.sortableTable.$el.querySelector('.el-table__body-wrapper tbody');
      if (!table) return
      this.sortableInstance = new Sortable(table, {
        handle: '.drag-handle', // 拖拽的手柄
        animation: 150, // 动画时间
        // ghostClass: 'sortable-ghost', // 拖拽时的占位样式
        // chosenClass: 'sortable-chosen', // 选中样式
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        // 拖拽结束时触发
        onEnd: (evt) => {
          const oldIndex = evt.oldIndex;
          console.log("🚀 ~ initSortable ~ oldIndex:", oldIndex)
          const newIndex = evt.newIndex;
          console.log("🚀 ~ initSortable ~ newIndex:", newIndex)
          // this.$nextTick(() => {
          // 移动数据
          const [movedItem] = this.tableData.splice(oldIndex, 1);
          console.log("🚀 ~ initSortable ~ movedItem:", movedItem)
          this.tableData.splice(newIndex, 0, movedItem);
          // 更新序号（如果需要同步sortIndex）
          this.tableData.forEach((item, index) => {
            item.sortIndex = index + 1 // 假设序号从1开始
          })
          console.log("🚀 ~ initSortable ~ this.tableData:", this.tableData)
          this.refreshKey += 1 // Key值变化触发组件重建
          // })
        }
      });
    },
    // 向上移动
    moveUp(index) {
      if (index === 0) return;
      const movedItem = this.tableData[index];
      // 移除当前项并插入到上一个位置
      this.tableData.splice(index, 1);
      this.tableData.splice(index - 1, 0, movedItem);
      // 同步更新序号
      this.tableData.forEach((item, i) => {
        item.sortIndex = i + 1
      })
      this.refreshKey += 1 // 触发表格刷新
    },

    // 向下移动
    moveDown(index) {
      if (index === this.tableData.length - 1) return;
      const movedItem = this.tableData[index];
      // 移除当前项并插入到下一个位置
      this.tableData.splice(index, 1);
      this.tableData.splice(index + 1, 0, movedItem);
      // 同步更新序号
      this.tableData.forEach((item, i) => {
        item.sortIndex = i + 1
      })
      this.refreshKey += 1 // 触发表格刷新
    },
    onConfirmSort() {
      this.$emit('setSort', this.tableData)
    },
    onCancel() {
      this.$emit('onCancelSort')
    }
  }
}

</script>
<style lang="scss" scoped>
</style>
